import { registerComponent } from "helpers";
import { WYATTPreferredStores } from "wyatt";

registerComponent(
  "preferred-store-button",
  class PreferredStoreButton extends WYATTPreferredStores {
    constructor() {
      super();

      this.makePreferred = this.querySelector("[data-make-preferred]");
      this.isPreferred = this.querySelector("[data-is-preferred]");

      this.makePreferred.removeAttribute("disabled");
      this.makePreferred.addEventListener("click", this.handleClick.bind(this));

      this.update();
    }

    disconnectedCallback() {
      WYATT.pubSub.unsubscribe(
        WYATT.pubSub.events.preferredStoreChange,
        this.update.bind(this)
      );
    }

    handleClick(event) {
      event.preventDefault();

      window.localStorage.setItem(
        WYATT.config.preferredStore.localStorageKey,
        this.config.storeID
      );

      WYATT.pubSub.publish(
        WYATT.pubSub.events.preferredStoreChange,
        this.config.storeID
      );
    }

    update() {
      if (this.config.storeID === this.preferredStoreID) {
        this.makePreferred.classList.add("hidden");
        this.isPreferred.classList.remove("hidden");
      } else {
        this.makePreferred.classList.remove("hidden");
        this.isPreferred.classList.add("hidden");
      }
    }
  }
);
